import { Phone, EnvelopeSimple } from "@phosphor-icons/react";
import { COMPANY } from "@/lib/constants";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-slate-950 text-slate-400 py-20 px-6 md:px-12 lg:px-16">
    <div className="max-w-7xl mx-auto text-center">
      <p className="uppercase text-xs tracking-[0.2em] font-semibold text-emerald-400">
        Get Your Cash Offer Today
      </p>
      <a
        href={COMPANY.phoneHref}
        data-testid="footer-phone-cta"
        className="block mt-6 font-heading text-[11vw] md:text-7xl font-bold text-white hover:text-emerald-400 transition-colors leading-none"
      >
        {COMPANY.phoneDisplay}
      </a>
      <p className="mt-6 text-lg text-slate-300">Call us 24/7 for a free, no-obligation cash offer.</p>

      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6">
        <a href={COMPANY.phoneHref} className="flex items-center gap-2 hover:text-white transition-colors">
          <Phone weight="fill" className="h-5 w-5" /> {COMPANY.phoneDisplay}
        </a>
        <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-white transition-colors">
          <EnvelopeSimple weight="fill" className="h-5 w-5" /> {COMPANY.email}
        </a>
      </div>

      <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
        <p>© 2026 {COMPANY.name}. All rights reserved.</p>
        <div className="flex gap-6">
          <a href="#top" className="hover:text-white transition-colors">Privacy Policy</a>
          <a href="#top" className="hover:text-white transition-colors">Terms of Service</a>
        </div>
      </div>
    </div>
  </footer>
);
